<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="far fa-ad" class="q-mb-sm" /> {{ $t('banner') }}
		</div>

		<div class="row gutter-sm q-mb-lg">
			<div class="col-xs-12 col-sm-12">
				<q-input
					v-model="title"
					ref="title"
					:float-label="$t('title')"
					:error="$v.title.$error"
					@input="$v.title.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-select
					v-model="banner_type"
					ref="banner_type"
					:options="bannerTypes"
					:float-label="$t('banner_type')"
					:error="$v.banner_type.$error"
					@input="$v.banner_type.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-field :helper="$t('no_www_starting_with_http_https')">
					<q-input
						v-model="url"
						ref="url"
						:float-label="$t('url')"
						:error="$v.url.$error"
						@input="$v.url.$touch"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12">
				<p class="caption">
					<a href="assets/banner-template-desktop.png" target="_blank">
						<q-icon name="fal fa-images"
					/></a>
					{{ $t('desktop_banner') }}
				</p>

				<uploader
					content_type="images"
					@fileUploaded="imageDesktopUploaded"
					:multiple="false"
					:cropper="true"
					:aspect_ratio="1600 / 340"
					:aspect_ratio_string="'1600/340'"
					:error="$v.image_desktop.$error"
					@input="$v.image_desktop.$touch"
				/>

				<p v-if="image_desktop" ref="image_desktop" class="q-mt-md file-url">
					<q-icon name="fal fa-check" color="positive" />
					<a :href="image_desktop" target="_blank"> {{ $truncateLink(image_desktop) }}</a>
				</p>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="showBanner">
				<p class="caption">
					<a href="assets/banner-template-mobile.png" target="_blank">
						<q-icon name="fal fa-images"
					/></a>
					{{ $t('mobile_banner') }}
				</p>

				<uploader
					content_type="images"
					@fileUploaded="imageMobileUploaded"
					:multiple="false"
					:cropper="true"
					:aspect_ratio="343 / 200"
					:aspect_ratio_string="'343/200'"
					:error="$v.image_mobile.$error"
					@input="$v.image_mobile.$touch"
				/>

				<p v-if="image_mobile" ref="image_mobile" class="q-mt-md file-url">
					<q-icon name="fal fa-check" color="positive" />
					<a :href="image_mobile" target="_blank"> {{ $truncateLink(image_mobile) }}</a>
				</p>
			</div>
			<!-- <div class="col-12">
				<q-select
					v-model="timezone"
					ref="timezone"
					:options="timezones"
					:float-label="$t('timezone')"
					filter
					:error="$v.timezone.$error"
					@input="$v.timezone.$touch"
				/>
			</div>
			<div class="col-xs-12 col-sm-6">
				<q-datetime
					v-model="start_date"
					ref="start_date"
					type="datetime"
					:float-label="$t('publish_date')"
					format="DD/MM/YYYY HH:mm"
					clearable
				/>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-datetime
					v-model="end_date"
					ref="end_date"
					type="datetime"
					:float-label="$t('end_date')"
					format="DD/MM/YYYY HH:mm"
					clearable
				/>
			</div> -->
		</div>

		<q-tabs v-model="tab" color="secondary" class="shadow-1">
			<q-tab
				slot="title"
				name="permissions"
				icon="fal fa-clipboard-list-check"
				:label="$t('areas_and_profiles')"
			/>

			<q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('areas') }}</p>
						<q-checkbox
							class="q-mb-sm"
							v-model="all_areas"
							:val="true"
							:label="$t('select_all_areas')"
							@input="checkAllAreas()"
						/>
						<q-select
							filter
							autofocus-filter
							v-model="area"
							ref="area"
							:options="areas"
							:error="$v.area.$error"
							@input="$v.area.$touch"
							multiple
							chips
						/>
					</div>

					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('profiles') }}</p>

						<div class="row gutter-sm">
							<div class="col-xs-12 col-sm-12">
								<q-checkbox
									v-model="all_profiles"
									:val="true"
									:label="$t('all')"
									@input="checkAll()"
								/>
							</div>

							<div
								class="col-xs-12 col-sm-4"
								v-for="(item, index) in profiles"
								:key="index"
								:class="getErrorClass($v.profile.$error)"
							>
								<q-checkbox
									keep-color
									v-model="profile"
									ref="profile"
									:val="item.value"
									:label="item.label"
									@input="$v.profile.$touch"
									:color="getErrorColor($v.profile.$error)"
								/>
							</div>
							<div class="col-xs-12 col-sm-12">
								<q-select
									v-model="user_group"
									ref="user_group"
									:options="user_groups"
									:float-label="$t('groups')"
									:error="$v.user_group.$error"
									@input="$v.user_group.$touch"
									multiple
									chips
								/>
							</div>
						</div>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm q-mt-md">
			<div class="col-xs-12 col-sm-12">
				<p class="caption">{{ $t('status') }}</p>
				<q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'admin_banners' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')" v-if="showDuplicateButton">
				<q-btn
					color="info"
					class="full-width"
					:label="$t('duplicate')"
					icon="fal fa-copy"
					@click="show_duplicate_modal = true"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>

		<duplicate :show="show_duplicate_modal" @hideDuplicate="hideDuplicate" />
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, url } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'
import Duplicate from './Duplicate'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'banners', 'admin'] },

	components: {
		uploader: Uploader,
		duplicate: Duplicate,
	},

	data() {
		return {
			id: '',
			title: '',
			banner_type: '',
			url: null,
			status: 1,
			statuses: [
				{
					label: this.$t('published'),
					value: 1,
				},
				{
					label: this.$t('unpublished'),
					value: 2,
				},
			],
			area: [],
			profile: [],
			user_group: [],
			all_profiles: false,
			tab: 'permissions',
			image_desktop: '',
			image_mobile: '',
			all_areas: false,
			show_duplicate_modal: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			faq_categories: 'registration_lists/faq_categories',
			areas: 'registration_lists/country_areas',
			user_groups: 'registration_lists/group_users',
			banner_types: 'registration_lists/banner_types',
			profiles: 'registration_lists/profiles',
			id_user_client_selected: 'common/id_user_client_selected',
			clients: 'params/clients',
			login_use_portfolio_page: 'params/login_use_portfolio_page',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		showBanner() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) {
				if (this.banner_type === 4) return true
				else if (obj.show_banner_mobile) return obj.show_banner_mobile
				else return false
			} else return true
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else return 'negative'
		},

		selectedClientModules() {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) return obj
			else return {}
		},

		bannerTypes() {
			return this.banner_types
				.filter((e) => {
					switch (e.label) {
						case 'trainings':
							return this.selectedClientModules.has_courses
							break
						case 'trails':
							return this.selectedClientModules.has_trails
							break
						case 'webinars':
							return this.selectedClientModules.has_webcasts
							break
						case 'home':
							return this.selectedClientModules.has_home
							break
						case 'portfolio':
							return this.login_use_portfolio_page
							break
						case 'podcasts':
							return this.selectedClientModules.has_podcasts
							break
						case 'live_classes':
							return this.selectedClientModules.has_live_classes
							break
						case 'library_files':
							return this.selectedClientModules.has_library
							break
						case 'news':
							return this.selectedClientModules.has_news
							break
						case 'presential':
							return this.selectedClientModules.has_presential
							break
						default:
							return true
							break
					}
				})
				.map((e) => ({
					...e,
					label: this.$t(e.label),
				}))
		},

		showDuplicateButton() {
			if (this.$route.params.id != 0) return true
			else return false
		},
	},

	methods: {
		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()
				let data = {}

				data.title = this.title
				data.banner_type = this.banner_type
				data.status = this.status
				data.image_desktop = this.image_desktop

				if (this.showBanner) data.image_mobile = this.image_mobile

				if (this.url !== null) data.url = this.url

				if (this.area.length > 0 && this.profile.length > 0) {
					data.areas = this.area
					data.profiles = this.profile
				}

				if (this.user_group.length > 0) data.user_group = this.user_group

				if (this.id != 0) {
					this.$axios
						.put(`/admin_banners/banners/${this.id}/`, data, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('banner_edit_success'),
								type: 'positive',
								icon: 'fal fa-save',
							})

							this.$router.push({ name: 'admin_banners' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else {
					this.$axios
						.post(`/admin_banners/banners/`, data, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()
							this.$q.notify({
								message: this.$t('banner_add_success'),
								type: 'positive',
								icon: 'fal fa-save',
							})

							this.$router.push({ name: 'admin_banners' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$formInputErrorFocus(this.$v, this.$refs)
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_banners/banners/${this.id}/`, this.getHeader)
				.then((response) => {
					this.title = response.data.title
					this.banner_type = response.data.banner_type
					this.image_desktop = response.data.image_desktop
					if (this.showBanner) this.image_mobile = response.data.image_mobile
					this.profile = response.data.profiles
					this.area = response.data.areas
					this.user_group = response.data.user_groups
					this.status = response.data.status
					this.url = response.data.url

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getErrorColor(state) {
			if (state) return 'negative'
			else return ''
		},

		getErrorClass(state) {
			if (state) return 'checkbox-error'
			else return ''
		},

		checkAll() {
			if (this.all_profiles) {
				this.profiles.forEach((element) => {
					this.profile.push(element.value)
				})
			} else {
				this.profile = []
			}
		},

		checkAllAreas() {
			if (this.all_areas) {
				this.area = this.areas.map((e) => e.value)
			} else {
				this.area = []
			}
		},

		imageDesktopUploaded(url) {
			this.image_desktop = url
		},

		imageMobileUploaded(url) {
			this.image_mobile = url
		},

		hideDuplicate() {
			this.show_duplicate_modal = false
		},
	},

	created() {
		this.id = this.$route.params.id

		if (this.id != 0) this.fetchData()
	},

	validations() {
		return {
			title: { required },
			banner_type: { required },
			image_desktop: { required },
			image_mobile: {
				requiredIf: requiredIf(() => {
					if (this.showBanner) return true
					else return false
				}),
			},
			url: { url },
			area: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},

			profile: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},
			user_group: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0
					) {
						return true
					} else {
						return false
					}
				}),
			},
		}
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'
a
    text-decoration none
    color black
</style>
